<template>
    <div class="statement">
        <div class="statement-header" v-if="showHeader === undefined || showHeader === true">
            <h2 class="col-lg-4 p-lg-0">
                {{ title }} 
                <button class="btn btn-default btn-add" v-ga="$ga.commands.newTransactionModalButton.bind(this, 'statement')"  data-toggle="modal" data-target="#newTransactionModal"><i class="fas fa-plus"></i></button>
            </h2>
            <div :class="{'statement-block-date col-lg': true}">
                <span v-if="statementLength > 0">{{ statement[firstKey].date }}</span>
            </div>
            <div class="statement-options col-lg-4 p-lg-0" v-if="filtersEnabled">
                <multiselect class="categories" v-model="filter.category" :options="filteredCategories" :placeholder="$t('Все категории')" label="name" track-by="id"></multiselect>
                <router-link to="/statement" class="search-btn">
                    <i class="fas fa-search"></i>
                </router-link>
            </div>
            <div :class="{'statement-amount col-lg-4 p-lg-0': true, 'income': statement[firstKey].summary > 0}"
                v-if="! filtersEnabled && statementLength > 0">
                <b>{{ statement[firstKey].summary | money }}</b> 
                <span class="currency"><i class="fas fa-hryvnia"></i></span>
            </div>
        </div>
        <div class="statement-empty" v-if="statementLength == 0 && isTransactionsLoaded">
            <slot>
                <div class="message">
                    {{ $t('Здесь будут отображатся ваши операции') }}
                </div>
                <a href="#" data-toggle="modal" data-target="#newTransactionModal">{{ $t('Добавить первую транзакцию') }}</a>
            </slot>
        </div>
        <TransactionLoader v-if="! isTransactionsLoaded" />
        <TransactionLoader v-if="! isTransactionsLoaded" />
        <TransactionLoader v-if="! isTransactionsLoaded" />
        <div v-if="isTransactionsLoaded">
            <div class="statement-block" v-for="(group, index) in statement" :key="index">
                <div class="statement-block-header" v-if="firstKey != index">
                    <div class="col-lg-4"></div>
                    <div class="statement-block-date col-lg" v-text="group.date"></div>
                    <div :class="{'statement-amount col-lg-4 p-lg-0': true, 'income': group.summary > 0}">
                        <b>{{ group.summary | money }}</b> 
                        <span class="currency"><i class="fas fa-hryvnia"></i></span>
                    </div>
                </div>

                <div :class="{'statement-item': true, 'clicked': clicked.includes(transaction.id), 'income': transaction.amount > 0}" v-for="transaction in group.transactions" 
                    :key="transaction.id"
                    @click="toggleTransaction(transaction)">
                    <div :class="['statement-item-icon', transaction.account.color_name]" v-text="transaction.category.icon"></div>
                    <div class="statement-info">
                        <div class="statement-description" v-text="transaction.description"></div>
                        <div :class="{'statement-category': transaction.description !== null, 'statement-description': transaction.description === null, }" v-text="transaction.category.title"></div>
                    </div>
                    <div class="statement-amount">
                        <b>{{ transaction.amount | money }}</b> 
                        <span class="currency"><i class="fas fa-hryvnia"></i></span>
                    </div>
                    <div class="remove-btn">
                        <a href="#" @click.prevent="deleteTransaction(transaction)" class="btn btn-danger">
                            <i class="fas fa-trash"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TransactionLoader from "@/components/Loaders/TransactionLoader.vue";
import { EventBus } from '../event-bus';

export default {
    name: 'Statement',

    components: {
        TransactionLoader,
    },

    props: ['title', 'filters', 'categories', 'statement', 'showHeader'],

    data: function() {
        return {
            filter: {
                description: null,
                category: null,
                category_id: null,
            },

            filtersEnabled: this.filters,

            clicked: [],

            state: 'loaded',

            stateChanger: {
                loaded: () => {
                    this.state = 'loaded'; 
                },
                complete: () => {
                    this.state = 'complete'; 
                },
            },
        };
    },

    watch: {
        "filter.description": function(newVal, oldVal) {
            this.filter.page = 1;

            this.loadWithFilters();
        },
        "filter.category": function(newVal, oldVal) {
            if(newVal === undefined || newVal === null) {
                this.filter.category_id = null;
            } else {
                this.filter.category_id = newVal.id;
            }

            this.filter.page = 1;
            
            this.loadWithFilters();
        },
    },

    computed: {
        ...mapGetters(['isTransactionsLoaded']),

        firstKey() {
            if(Object.keys(this.statement).length == 0) {
                return null;
            }

            return Object.keys(this.statement)[0];
        },

        statementLength() {
            return Object.keys(this.statement).length;
        },

        filteredCategories: function() {
            return this.categories.filter((category) => {
                return true;
            });
        },
    },

    mounted() {
        document.getElementById('page-content-wrapper').addEventListener('scroll', this.scroll);
    },

    beforeDestroy() {
        document.getElementById('page-content-wrapper').removeEventListener('scroll', this.scroll);
    },

    methods: {
        ...mapActions(['loadTransactions']),

        toggleTransaction(transaction) {
            EventBus.$emit('edit-transaction', transaction.id);

            // if(this.clicked.includes(transaction.id)) {
            //     this.clicked = this.clicked.filter((id) => id != transaction.id);

            //     return;
            // }
            
            // this.clicked.push(transaction.id);
        },

        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);

            return `${title} — ${balance} ${currency}`;
        },

        scroll() {
            let bottomOfWindow = (document.getElementById('page-content-wrapper').scrollTop + document.getElementById('page-content-wrapper').offsetHeight) >= document.getElementById('page-content-wrapper').scrollHeight - 200;

            if (bottomOfWindow && this.state !== 'loading' && this.state !== 'complete') {
                this.state = 'loading';

                this.$emit('scrolled', () => {
                    this.state = 'loaded';
                });
            }
        },

        loadWithFilters() {
            this.loadTransactions({filters: this.filter});
        },

        deleteTransaction(transaction) {
            axios.delete(`/transactions/${transaction.id}`)
                .then(() => {
                    this.$emit('deleted', transaction);
                }).catch(() => {
                    //
                });
        }
    },
}
</script>

<style scoped lang="scss">
@import '../assets/scss/_card_colors.scss';

.statement {
    padding-top: 15px;

    @media (max-width: 991px) {
        padding-top: 0;
    }

    .statement-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        h2 {
            font-style: normal;
            font-weight: 500;
            font-size: 28px;

            color: #252A32;

            @media (max-width: 767px) {
                font-size: 21px;
                margin-bottom: 0;
                padding-left: 0;
            }
        }

        .btn-add {
            @media(max-width: 767px) {
                display: none;
            }
        }

        .statement-options {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            
            @media (max-width: 767px) {
                padding-right: 0;

                .categories {
                    display: none!important;
                }
            }

            .categories {
                background: transparent;
                border: 1px solid #e8e8e8;
                box-sizing: border-box;
                outline: 0;
                border-radius: 50px;

                font-style: normal;
                font-weight: normal;
                font-size: 12px;

                color: rgba(37, 42, 50, 0.5);

                display: flex;
                align-items: center;

                .multiselect__tags {
                    overflow-x: hidden;
                    text-overflow: unset;
                    white-space: nowrap;
                    padding: 0;
                    border-radius: 50px;
                    border: none;
                }
            }

            .search-btn {
                background: transparent;
                outline: 0;
                border: 1px solid #e8e8e8;
                box-sizing: border-box;
                border-radius: 50px;
                padding: 6px 9px;
                margin-left: 7px;

                font-style: normal;
                font-weight: normal;
                font-size: 12px;

                color: rgba(37, 42, 50, 0.5);
            }
        }
    }

    .statement-block-date {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        text-align: center;

        color: rgba(37, 42, 50, 0.5);
    }

    .statement-amount {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #252A32;
        
        &.income {
            color: #58CC97;
        }

        b {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;

            display: flex;
            align-items: center;
            text-align: right;

            @media (max-width: 767px) {
                font-size: 15px;
            }
        }

        .currency {
            font-size: 11px;
            margin-bottom: -5px;
            margin-left: 3px;

            @media (max-width: 767px) {
                font-size: 9px;
            }
        }
    }

    .statement-empty {
        width: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        flex-direction: column;

        padding: 50px 0;

        .message {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 19px;
            text-align: justify;

            color: #252A32;
        }

        a {
            display: block;
            margin-top: 10px;
            color: #336EBD;
            text-decoration: none;
        }
    }

    .statement-block {
        width: 100%;

        @media (max-width: 767px) {
            .statement-block-header {
                > :last-child {
                    padding-right: 0;
                }

                .statement-block-date {
                    //
                }
            }
        }

        .statement-block-header {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 30px 0 20px;

            @media (max-width: 991px) {
                position: sticky;
                top: 0;
                background: rgb(255 255 255 / 95%);
                padding: 5px 0px;
                margin: 20px 0 0;
            }
            
            .statement-block-date {
                margin-left: auto;
            }
        }

        .statement-item {
            border-left: 2px solid #E3342F;
            
            &.income {
                border-color: #58CC97;

                @media (max-width: 767px) {
                    .statement-item-icon {
                        border-color: #58CC97;
                        box-shadow: 0px 0 15px -6px #58CC97;
                    }
                }
            }

            @media (max-width: 767px) {
                border: none;
            }

            width: 100%;

            display: flex;
            align-items: center;
            margin: 20px 0;

            .statement-item-icon {
                font-style: normal;
                font-weight: bold;
                font-size: 19px;
                display: flex;
                text-align: center;
                align-items: center;
                justify-content: center;
                margin-left: 10px;

                // background: linear-gradient(225deg, #010101 0%, #333333 100%);
                width: 48px;
                min-width: 48px;
                height: 48px;
                border-radius: 50%;

                box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

                &.color-black {
                    background: $color-black;
                }

                &.color-gray {
                    background: $color-gray;
                }

                &.color-red {
                    background: $color-red;
                }

                &.color-yellow {
                    background: $color-yellow;
                }

                &.color-rose {
                    background: $color-rose;
                }

                &.color-blue {
                    background: $color-blue;
                }

                &.color-green {
                    background: $color-green;
                }

                &.color-white {
                    background: $color-white;
                }

                @media (max-width: 767px) {
                    width: 35px;
                    min-width: 35px;
                    height: 35px;
                    font-size: 13px;
                    margin-left: 0;
                    border: 1px solid #E3342F;
                    box-shadow: 0px 0 15px -6px #E3342F;
                }
            }

            .statement-info {
                margin-left: 15px;

                @media (max-width: 767px) {
                    margin-left: 10px;
                }

                .statement-description {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;

                    color: #252A32;

                    @media (max-width: 767px) {
                        font-size: 14px;
                    }
                }
                
                .statement-category {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;

                    color: rgba(37, 42, 50, 0.5);

                    @media (max-width: 767px) {
                        font-size: 11px;
                    }
                }
            }

            .statement-amount {
                display: flex;
                align-items: center;
                margin-left: auto;
                color: #252A32;

                b {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;

                    display: flex;
                    align-items: center;
                    text-align: right;

                    @media (max-width: 767px) {
                        font-size: 15px;
                    }
                }

                .currency {
                    font-size: 11px;
                    margin-bottom: -5px;
                    margin-left: 3px;

                    @media (max-width: 767px) {
                        font-size: 9px;
                    }
                }
            }

            .remove-btn {
                display: none;
                margin-left: 20px;
                position: relative;
                margin-right: -60px;
                opacity: 0;
                transition: 0.3s;
            }

            &.clicked {
                .remove-btn {
                    display: block;
                    margin-right: 0;
                    opacity: 1;
                }
            }

            &.income {
                .statement-amount {
                    color: #58CC97;
                }
            }
        }
    }
}
</style>